import NovoCriativo from "../../../components/Cadastros/Novo/NovoCriativo";
import Header from "../../../components/Menu";

const NovoCriativoPage = () => {
  return (
    <div className="flex">
      <Header />
      <NovoCriativo />
    </div>
  );
};

export default NovoCriativoPage;
